import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { navigate } from "gatsby";

import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { cn } from "@helpers/general";

import IconArrow from "../icons/svgs/arrow.svg";

function ProductAlternativeDropdownBlock({
  pageProductHandle,
  alternatives,
  labelTitle,
  stepPrefix = "",
}) {
  const [sortedAlternatives, setSortedAlternatives] = useState(alternatives);
  const isMultiStep = stepPrefix !== "";

  useEffect(() => {
    const sortedAlternativesCopy = [...alternatives];

    const orderIndex = {};
    const CUSTOM_ORDER = [
      // Size example 1
      "Mini",
      "Small",
      "Medium",
      "Large",
      // Size example 2
      "Slim",
      "Bold",
    ];
    CUSTOM_ORDER.forEach((item, index) => {
      orderIndex[item] = index;
    });

    // Order alternatives
    sortedAlternativesCopy.sort((a, b) => {
      const [aLabelName] = a.attrArgs;
      const [bLabelName] = b.attrArgs;

      const indexA = orderIndex[aLabelName] !== undefined ? orderIndex[aLabelName] : Infinity;
      const indexB = orderIndex[bLabelName] !== undefined ? orderIndex[bLabelName] : Infinity;

      return indexA - indexB;
    });
    setSortedAlternatives(sortedAlternativesCopy);
  }, [alternatives]);

  if (!sortedAlternatives?.length) return null;
  const alternativesToDisplay = sortedAlternatives.filter((a) => a.isFound);

  return (
    <div key={labelTitle} className={cn(isMultiStep ? "mb-[30px]" : "mb-[25px] mobile:mb-[20px]")}>
      <div className="mb-[10px]">
        <span className="pr-[10px] typo-body font-bold">
          {stepPrefix}
          {labelTitle}
        </span>
      </div>
      <div className={cn("flex relative")}>
        <select
          id="product-alternative"
          className={cn(
            "text-black rounded-md border border-[#898786] px-[20px] py-[9px] m-0 bg-transparent cursor-pointer appearance-none indent-[1px] w-full gap-x-[10px] gap-y-[7px]"
          )}
          value={pageProductHandle}
          onChange={(e) => navigate(`/products/${e.target.value}`)}
        >
          {alternativesToDisplay.map((a) => {
            const [labelName] = a.attrArgs;
            const isActive = pageProductHandle === a.handle;
            return (
              <option
                key={`select-option-alternatives-${a.handle}`}
                value={a.handle}
                aria-current={isActive ? "true" : undefined}
              >
                {labelName} {!a.availableForSale ? " (Sold Out)" : ""}
              </option>
            );
          })}
        </select>
        <IconArrow
          fill="#000000"
          width="13"
          height="13"
          className="absolute top-[15px] mobile:top-[12px] right-[22px] -rotate-90 -z-[1]"
        />
      </div>
    </div>
  );
}

ProductAlternativeDropdownBlock.propTypes = {
  pageProductHandle: PropTypes.string.isRequired,
  alternatives: PropTypes.arrayOf(
    PropTypes.shape({
      attrArgs: PropTypes.arrayOf(PropTypes.string).isRequired,
      isFound: PropTypes.bool.isRequired,
      handle: PropTypes.string.isRequired,
      attrName: PropTypes.string.isRequired,
      availableForSale: PropTypes.bool.isRequired,
    })
  ),
  labelTitle: PropTypes.string.isRequired,
  stepPrefix: PropTypes.string,
};

export default withALErrorBoundary({
  name: "ProductAlternativeDropdownBlock",
  priority: "P2",
})(ProductAlternativeDropdownBlock);
